import React, { useState, useEffect } from "react";
import { Comment, Layout, Drawer, Avatar, Typography, Button, Alert, notification } from "antd";
import { fmtDateTime } from "../../common/Utils";
import avatar from "../../images/avatar.png";
import logoAvatar from "../../images/logo-avatar.png";
import TextArea from "antd/lib/input/TextArea";
import { useMutation } from "@apollo/react-hooks";
import { ResponseFeedback } from "../../graphql/feedback";

export const FeedbackSider = ({ visible, curItem, onClose, onUpdate }) => {
  const [response, setResponse] = useState("");
  const [responseFeedback, { loading }] = useMutation(ResponseFeedback);
  const onResolved = () => {
    responseFeedback({
      variables: { input: { id: curItem?.id, resolved: "1" } },
    }).then((res) => {
      onUpdate(res.data.responseFeedback);
      notification.info({ message: "Success!" });
    });
  };

  const onResponse = () => {
    responseFeedback({
      variables: {
        input: { id: curItem?.id, content: response, resolved: "-" },
      },
    }).then((res) => {
      onUpdate(res.data.responseFeedback);
      setResponse("");
      notification.info({ message: "Success!" });
    });
  };

  useEffect(() => {
    setResponse("");
  }, [curItem]);

  return (
    <Layout.Sider
      collapsed={!visible || !curItem}
      theme="light"
      reverseArrow
      collapsible
      collapsedWidth={0}
      width={400}
      zeroWidthTriggerStyle={{ display: "none" }}
      style={{
        overflow: "auto",
        position: "fixed",
        right: 0,
        top: 64,
        bottom: 0,
      }}
    >
      <Drawer
        mask={false}
        title="Feedback Details"
        placement="right"
        width={400}
        onClose={onClose}
        visible={visible && curItem}
        getContainer={false}
        style={{ position: "absolute" }}
      >
        <Alert
          message={
            <div>
              Users can read your response but they cannot reply back. If you need to communicate with a user, please
              contact them via email or phone.
              <br />
              Please thank our users for their feedback whenever possible.
              <br />
              Closing Case ends your ability to see a feedback, so do so only after an issue is completely resolved.
            </div>
          }
          type="warning"
        />

        <Comment
          author={curItem?.user?.name}
          avatar={
            <Avatar
              src={
                curItem?.user?.avatar
                  ? `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${curItem?.user?.avatar}`
                  : avatar
              }
              alt={curItem?.user?.name}
            />
          }
          content={
            <div>
              <Typography.Text strong>{curItem?.title}</Typography.Text>
              <Typography.Paragraph>{curItem?.content}</Typography.Paragraph>
            </div>
          }
          datetime={fmtDateTime(curItem?.createDate)}
        >
          {curItem?.responses?.map((r) => (
            <Comment
              author={r.employeeName}
              avatar={<Avatar src={logoAvatar} alt={r.employeeName} />}
              content={
                <div>
                  <Typography.Paragraph>{r?.content}</Typography.Paragraph>
                </div>
              }
              datetime={fmtDateTime(r?.createDate)}
            />
          ))}
          {curItem?.resolved !== "1" && (
            <Comment
              avatar={<Avatar src={logoAvatar} />}
              content={
                <div>
                  <TextArea rows={6} value={response} onChange={(e) => setResponse(e.target.value)} />
                  <div style={{ marginTop: 4, textAlign: "right" }}>
                    <Button.Group size="small">
                      <Button disabled={!response.trim()} loading={loading} type="primary" onClick={() => onResponse()}>
                        Send
                      </Button>
                      <Button loading={loading} type="default" onClick={() => onResolved()}>
                        Close Case
                      </Button>
                    </Button.Group>
                  </div>
                </div>
              }
            ></Comment>
          )}
        </Comment>
      </Drawer>
    </Layout.Sider>
  );
};
